import { JSX, ReactNode, createContext, useContext, useState } from 'react';
import type { SupportedModules } from '../providers/FeatureFlag.provider';

type OpenModuleCtx = {
  openModule: SupportedModules;
  setOpenModule: (newOpenModule: SupportedModules) => void;
};

export const OpenModuleContext = createContext<OpenModuleCtx>({
  openModule: 'dashboard',
  setOpenModule: () => {},
});

export const OpenModuleProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const [openModule, setOpenModule] = useState<SupportedModules>('dashboard');

  const handleSetOpenModule = (newOpenModule: SupportedModules) => {
    setOpenModule(newOpenModule);
  };

  return (
    <OpenModuleContext.Provider value={{ openModule, setOpenModule: handleSetOpenModule }}>
      {children}
    </OpenModuleContext.Provider>
  );
};

export const useOpenModule = (): OpenModuleCtx => useContext(OpenModuleContext);
